import React, {useEffect} from 'react';
import {BrowserRouter, Route, Routes, useNavigate, useParams} from 'react-router-dom';

import './App.scss';
import Vehicle from "./vehicle/vehicle";
import Compare from "./compare/compare";
import Layout from "./Layout";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import Photos from "./Photos/Photos";
import {useBodyBackground} from "./vehicleSection/useBodyBackground";
import {
    clearCompareData,
    sendErrorMessage,
    setErrorMessage
} from "../slices/vehicleSlice";
import {useDispatch, useSelector} from "react-redux";
import ErrorModal from "./Modal/ErrorModal";
import LegalModal from "./legal_modal/legalModal";
import {GoogleTagManager} from "./GoogleTagManager";

const theme = createTheme(({
    typography: {
        allVariants: {
            fontFamily: 'sans-serif',
        }
    }
}))

function App() {
    if (window.location.hash !== ''){
        let replaceValue = '/#/';
        if (window.location.hash.includes('select/primary/compare/')) {
            replaceValue = '/#/select/primary/compare/';
        }
        window.location.replace(window.location.href.replace(replaceValue, '/'));
    }
    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.setItem('isReload', 'true');
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);
    return (
        <div className="appContainer">
            <ThemeProvider theme={theme}>
                <GoogleTagManager/>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Layout/>}>
                            <Route index element={<Vehicle/>}/>
                            <Route path='/:client/vehicle/:language' element={<VehicleData/>} />
                            <Route path='/:client/:country/:language/vehicle' element={<VehicleData/>} />
                            <Route path='/:client/vehicle' element={<VehicleData/>} />
                            <Route path='/:client/:country/vehicle' element={<VehicleData/>} />
                            <Route path='/:client/:country/:language/compare/features/:code/:codes' element={<CompareData />}/>
                            <Route path='/:client/:country/:language/compare/features/:code' element={<CompareData />}/>

                            <Route path='/cars/compare-cars/compare/features/' element={<CompareData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/compare/features/:code' element={<CompareData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/compare/features/:code/:codes' element={<CompareData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/:country/compare/features/' element={<CompareData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/:country/compare/features/:code' element={<CompareData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/:country/compare/features/:code/:codes' element={<CompareData JDPALoad={true} />}/>
                            <Route path='/:client/compare/features/:code/:codes' element={<CompareData />}/>
                            <Route path='/:client/:country/compare/features/:code/:codes' element={<CompareData />}/>
                            <Route path='/:client/:country/:language/compare/features/:code' element={<CompareData />}/>
                            <Route path='/:client/compare/features/:code' element={<CompareData />}/>
                            <Route path='/:client/:country/compare/features/:code' element={<CompareData />}/>

                            <Route path='/cars/compare-cars/compare/photos/:code' element={<PhotosData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/compare/photos/:code/:codes' element={<PhotosData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/:country/compare/photos/:code' element={<PhotosData JDPALoad={true} />}/>
                            <Route path='/cars/compare-cars/:country/compare/photos/:code/:codes' element={<PhotosData JDPALoad={true} />}/>
                            <Route path='/:client/compare/photos/:code/' element={<PhotosData />}/>
                            <Route path='/:client/:country/compare/photos/:code/' element={<PhotosData />}/>
                            <Route path='/:client/:country/:language/compare/photos/:code/' element={<PhotosData />}/>
                            <Route path='/:client/:country/:language/compare/photos/:code/:codes' element={<PhotosData />}/>
                            <Route path='/:client/:country/compare/photos/:code/:codes' element={<PhotosData />}/>
                            <Route path='/:client/compare/photos/:code/:codes' element={<PhotosData />}/>

                        </Route>
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </div>
    );
}

function VehicleData() {
    const { client, country, language, codes } = useParams();
    const defaultLanguage = 'en';
    const languageParam = language || defaultLanguage;
    const trimCodes = codes || '';
    useBodyBackground('#fff');
    const errorMessage = useSelector(setErrorMessage);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const handleErrorModal = () => {
        if (errorMessage === "COMPARE-API-001"){
            const defaultCountry = country === undefined || '' ? '' : `/${country}`;
            dispatch(clearCompareData())
            navigate(`/${client}${defaultCountry}/vehicle/`);
        }
        dispatch(sendErrorMessage({error:null,errorCode:errorMessage}))
    }

    useEffect(() => {
        document.title = 'Select Vehicle';
    }, []);

        return (
            <>
                <Vehicle client={client}
                         country={country === 'es' ? 'us' : country}
                         language={country === 'es' ? 'es' : languageParam}
                         codes={trimCodes}/>
                <ErrorModal errorMessage={errorMessage}
                            handleErrorModal={handleErrorModal}
                />
                <LegalModal client={client}
                            country={country}/>
            </>
        );
}

function CompareData( JDPALoad ) {
    const { client, country, language, code, codes } = useParams();
    const defaultLanguage = 'en';
    const languageParam = language || defaultLanguage;
    const trimCodes = codes || '';
    const primaryCode = code || '';
    useBodyBackground('#e7e7e7');
    const errorMessage = useSelector(setErrorMessage);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const clientValue = (JDPALoad?.JDPALoad && !client) || client === 'cars' ? 'jdpa' : client;
    const handleErrorModal = () => {
        if (errorMessage === "COMPARE-API-001"){
            const defaultCountry = country === undefined || '' ? '' : `/${country}`;
            dispatch(clearCompareData())
            navigate(`/${clientValue}${defaultCountry}/vehicle/`);
        }
        dispatch(sendErrorMessage({error:null,errorCode:errorMessage ? errorMessage : null}))
    }

    useEffect(() => {
        document.title = 'Compare';
    }, []);

    if (country) {
        return (<>
            <Compare client={clientValue} country={country === 'es' ? 'us' : country} language={country === 'es'? 'es' :languageParam } primary={primaryCode} codes={trimCodes} />
            <ErrorModal errorMessage={errorMessage}
                        handleErrorModal={handleErrorModal}
            />
            <LegalModal client={clientValue}
                        country = {country}/>

        </>);
    } else {
        return (<>
            <Compare client={clientValue} country={country === 'es' ? 'us' : country} language={country === 'es'? 'es' :languageParam } primary={primaryCode} codes={trimCodes} />
            <ErrorModal errorMessage={errorMessage}
                        handleErrorModal={handleErrorModal}

            />
            <LegalModal client={clientValue}
                        country = {country}/>
        </>);
    }
}


function PhotosData( JDPALoad ) {
    const { client, country, language, code,codes } = useParams();
    const defaultLanguage = 'en';
    const languageParam = language || defaultLanguage;
    const trimCodes = codes || '';
    const primaryCode = code || '';

    useBodyBackground('#e7e7e7');

    useEffect(() => {
        document.title = 'Compare';
    }, []);
    const errorMessage = useSelector(setErrorMessage);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const clientValue = JDPALoad?.JDPALoad && !client ? 'jdpa' : client;
    const handleErrorModal = () => {
        if (errorMessage === "COMPARE-API-001"){
            const defaultCountry = country === undefined || '' ? '' : `/${country}`;
            dispatch(clearCompareData())
            navigate(`/${clientValue}${defaultCountry}/vehicle/`);
        }
        dispatch(sendErrorMessage({error:null,errorCode:errorMessage ? errorMessage : null}))

    }

    if (country){
        return (
            <>
                <Photos client={clientValue} country={country === 'es' ? 'us' : country} language={country === 'es'? 'es' :languageParam } code={primaryCode} codes={trimCodes} />
                <ErrorModal errorMessage={errorMessage}
                            handleErrorModal={handleErrorModal}

                />
                <LegalModal client={clientValue}
                            country = {country}/>
            </>)
    }else{
        return (
            <>
              <Photos client={clientValue} country={country === 'es' ? 'us' : country} language={country === 'es'? 'es' :languageParam } code={primaryCode} codes={trimCodes}  />
                <ErrorModal errorMessage={errorMessage}
                            handleErrorModal={handleErrorModal}

                />
                <LegalModal client={clientValue}
                            country = {country}/>
            </>)
    }
}
export default App;
